import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ToolsMixin extends Vue {

  public groupByKeyValue(xs: any, key: string) {
    const result: any = {};
    for (const index of Object.keys(xs)) {
      const value = xs[index];
      if (!(value[key] in result)) {
        result[value[key]] = [];
      }
      result[value[key]].push(value);
    }
    return result;
  }

}
